/** @format */
import { Context, createContext } from 'react';

import { AvailableMarket, Market } from '@toucan/client/global/market';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface MarketContextProps {
    activeMarket: Market;
    availableMarkets: AvailableMarket[];
    reloadFixtures: () => Promise<void>;
}

export const MarketContext: Context<MarketContextProps> = createContext(
    {} as MarketContextProps
);

MarketContext.displayName = 'MarketContext';
